/* Packages */
import React from 'react';
import { render } from 'react-dom';

/* Components */
import FavoritesCount from './components/FavoritesCount';

/* utilities */
import { parseDataToProps } from '~/utilities';

const FavoritesCountNodes = Array.from(document.querySelectorAll("[data-favorites-count]"));
[...FavoritesCountNodes].forEach((node) => render(<FavoritesCount {...parseDataToProps(node.dataset)} />, node));
